import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography,
  createStyles,
  Theme,
  makeStyles,
  Button,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 600,
      [theme.breakpoints.down('sm')]: {
        minWidth: '90%',
      },
    },
    title: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
    dialogActions: {
      padding: theme.spacing(2),
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    dialogButton: {
      margin: theme.spacing(0.5),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  }),
);

export interface DialogActionType {
  open: boolean;
  title: string;
  subtitle?: string;
  actions: {
    btnText: string;
    action: () => void;
    color: 'default' | 'primary' | 'secondary';
  }[];
}

interface IProps {
  dialogActions: DialogActionType;
  setDialog: React.Dispatch<React.SetStateAction<DialogActionType>>;
}
const DialogWarnActions: React.FC<IProps> = ({ dialogActions, setDialog }) => {
  const classes = useStyles();

  const handleClose = () => {
    setDialog({ open: false, title: '', actions: [] });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="aviso"
      open={dialogActions.open}
      PaperProps={{ className: classes.root }}
    >
      <DialogTitle disableTypography className={classes.title}>
        <Typography variant="h6">{dialogActions.title}</Typography>

        {dialogActions.subtitle && (
          <Typography variant="body1" style={{ color: '#FE0000' }}>
            {dialogActions.subtitle}
          </Typography>
        )}

        {handleClose && (
          <IconButton
            aria-label="fechar-aviso"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogActions>
        <div className={classes.dialogActions}>
          {dialogActions.actions.map((act) => (
            <Button
              className={classes.dialogButton}
              onClick={act.action}
              color={act.color}
              variant="outlined"
              size="small"
            >
              {act.btnText}
            </Button>
          ))}
          <Button
            className={classes.dialogButton}
            autoFocus
            onClick={handleClose}
            color="secondary"
            variant="outlined"
            size="small"
          >
            Fechar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DialogWarnActions;
